module.exports = __webpack_public_path__ + "img/default-browse-vehicles-cjdr.1e306c4b.png";